module.exports = __webpack_public_path__ + "img/chongci_ps_06.429d07b5.jpg";